import * as React from "react";
import { Alert, Box } from "@mui/material";
import CclGenericAccordian from "../../../../components/common/cclGenericAccordian";
import CclInfoTable, {
    CclInfoTableRowTemplate,
} from "../../../../components/common/cclInfoTable/cclInfoTable";
import { Profile } from "../../../../services/types/enterpriseCoachingApiTypes";
import { flattenObject } from "../../../../utilities/flattenObject";
import { CclInfoTblResourceInfoTemplate } from "../../../resources/resourceDetail/info/cclInfoTblResourceInfoTemplate";
import { useGetResourceByEmailQuery } from "../../../../services/cclTokenedResourceApi";
import { useGetCclUserAccountDetailQuery } from "../../../../services/cclTokenedGrandCentralApi";

export type D365DetailsCardProps = {
    emailAddress: string;
    profile: Profile;
};

const D365DetailsCard: React.FC<D365DetailsCardProps> = (props) => {
    const [modTemplate, setModTemplate] = React.useState<CclInfoTableRowTemplate[]>([]);

    const { data: enterpriseData } = useGetCclUserAccountDetailQuery(props.emailAddress, {
        skip: props.emailAddress == null || props.emailAddress === "",
    });
    const { data: resource } = useGetResourceByEmailQuery(props.emailAddress, {
        skip: props.emailAddress == null || props.emailAddress === "",
    });

    React.useEffect(() => {
        if (!props.profile || !props.profile.email) return;
        const enterpriseDetail = enterpriseData?.find(
            (e) => e.email.toLowerCase() === props.profile.email.toLowerCase(),
        );

        var newTemplate = CclInfoTblResourceInfoTemplate.map((r) => ({
            ...r,
            valueField: { ...r.valueField },
        }));
        var rowitem = newTemplate.find((r) => r.id === "ceContactId");
        if (typeof rowitem !== "undefined" && rowitem !== null) {
            rowitem.valueField.value = enterpriseDetail?.ceContactId ?? "";
        }

        rowitem = newTemplate.find((r) => r.id === "bookableresourceid");
        if (typeof rowitem !== "undefined" && rowitem !== null && resource) {
            rowitem.valueField.value =
                resource[0]?.bookableresourceid ?? "This user has no bookable resource id";
        }

        setModTemplate([...newTemplate]);
    }, [props.profile, enterpriseData, resource]);

    return (
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
            <CclGenericAccordian headingText={"D365"} sx={{ height: 1 }}>
                {!props.profile.email && (
                    <Alert severity="info">
                        No D365 Bookable Resource Record exists for this user{" "}
                    </Alert>
                )}
                {props.profile.email && (
                    <CclInfoTable
                        template={modTemplate}
                        data={flattenObject(props.profile)}
                        onSave={() => {}}
                        onChange={() => {}}
                    />
                )}
            </CclGenericAccordian>
        </Box>
    );
};

export default D365DetailsCard;
